'use client';

import { c as _c } from "react/compiler-runtime";
import type React from 'react';
type Status = 'pending' | 'approved' | 'rejected';
type Item = {
  id: string;
  status: Status;
};
const STATUS_LABEL: Record<Status, string> = {
  pending: 'Pending',
  approved: 'Approved',
  rejected: 'Rejected'
};
const STATUS_CLASS: Record<Status, string> = {
  pending: 'bg-textSecondary/10 text-textSecondary',
  approved: 'bg-emerald-500/10 text-emerald-500',
  rejected: 'bg-red-500/10 text-red-500'
};
export function CandidateList(t0) {
  const $ = _c(9);
  const {
    items,
    render,
    empty: t1
  } = t0;
  const empty = t1 === undefined ? "None yet." : t1;
  if (items.length === 0) {
    let t2;
    if ($[0] !== empty) {
      t2 = <p className="mt-2 text-xs italic text-textSecondary">{empty}</p>;
      $[0] = empty;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  }
  let t2;
  if ($[2] !== items || $[3] !== render) {
    let t3;
    if ($[5] !== render) {
      t3 = item => <li key={item.id} className="flex items-center gap-3 rounded-md border border-ds-border-subtle px-3 py-2 text-sm"><span className="min-w-0 flex-1 truncate">{render(item)}</span><span className={`shrink-0 rounded-full px-2 py-0.5 text-xs font-medium ${STATUS_CLASS[item.status]}`}>{STATUS_LABEL[item.status]}</span></li>;
      $[5] = render;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t2 = items.map(t3);
    $[2] = items;
    $[3] = render;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = <ul className="mt-2 space-y-1.5">{t2}</ul>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}